import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "./message.service";

@Injectable({
    providedIn: 'root'
})

export class PaymentService {

    private registerPaymentUrl = location.origin + '/api/payment/register/';

    private billPaymentUrl = location.origin + '/api/payment/bill/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    private httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    private getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    getRegisterPaymentList(isAdmin, unPaid, allPayment) {
        return this.http.get<any>(`${this.registerPaymentUrl}get/list?admin=${isAdmin}&unPaid=${unPaid}&allPayment=${allPayment}`, { headers: this.getToken() })
            .pipe();
    }

    uploadDocument(id, data) {
        return this.http.post<any>(`${this.billPaymentUrl}upload/${id}`, data, { headers: this.getToken() })
            .pipe();
    }

    getBillPaymentList(isAdmin) {
        return this.http.get<any>(`${this.billPaymentUrl}get/list?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }

    getBillPaymentById(paymentId:string) {
        return this.http.get<any>(`${this.billPaymentUrl}get/detail/${paymentId}`, { headers: this.getToken() })
            .pipe();
    }


    updateBillPaymentStatus(id, status) {
        return this.http.get<any>(`${this.billPaymentUrl}update/status/${id}/${status}`, { headers: this.getToken() })
            .pipe();
    }

    updateRegisterPaymentStatus(id, status) {
        return this.http.get<any>(`${this.registerPaymentUrl}update/status/${id}/${status}`, { headers: this.getToken() })
            .pipe();
    }

    getMonthOptionsForBillPayment(isAdmin){
        return this.http.get<any>(`${this.billPaymentUrl}month/options?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }

    getMonthOptionsForRegisterPayment(isAdmin){
        return this.http.get<any>(`${this.registerPaymentUrl}month/options?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }

    getPaymentValuesForDashboard(isAdmin){
        return this.http.get<any>(`${this.billPaymentUrl}dashboard?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }
}